import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
import { PointType } from "../../organism/PointSection";
interface Props extends PointType {
  index: string;
}
const Wrapper = /*#__PURE__*/styled("article")({
  name: "Wrapper",
  class: "wavjsa3",
  vars: {
    "wavjsa3-0": [({
      image
    }) => `url(${image}) center/cover no-repeat`]
  }
});
const Case = /*#__PURE__*/styled("div")({
  name: "Case",
  class: "c1txpf8q"
});
const Overlay = /*#__PURE__*/styled("div")({
  name: "Overlay",
  class: "ohjxhv5"
});
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c1obfdst"
});

const PointCard = ({
  title,
  subtitle,
  image,
  index,
  description
}: Props) => {
  return <Wrapper image={image}>
      <Overlay />
      <Content>
        <Case>
          Case<span>{index}</span>
        </Case>
        <h4>{title}</h4>
        <p className="subtitle">{subtitle}</p>
        <p className="description">{description}</p>
      </Content>
    </Wrapper>;
};

export { PointCard };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");